import ExternalLink from "./ExternalLink";
export default ExternalLink;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navigation/ExternalLink/index.tsx